export function cutLastPart(): string {
  const separator = '/';
  const pathname = window.location.pathname;
  if (pathname === separator) return separator;
  const pathArray = pathname.split(separator);
  if (pathArray.length === 1 && pathArray[0] === pathname) return pathname;
  if (pathArray[pathArray.length - 1]) {
    return pathArray.slice(0, -1).join(separator);
  } else {
    return pathArray.slice(0, -2).join(separator);
  }
}

export function getClientSecretUrl(): string {
  const path = cutLastPart();
  // TODO: !!! Check why it was not working on prod but was on local dev. See commit-message changes
  if (path === '/') {
    return '/php/api-proxy-call.php';
  }
  if (path.slice(-1) === '/') {
    return path.slice(0, -1) + '/php/api-proxy-call.php';
  }
  return path + '/php/api-proxy-call.php';
}

export function getIustaOvmLinkUrl(): string {
  const path = cutLastPart();
  if (path === '/') {
    return '/php/iusta-ovm-link.php';
  }
  if (path.slice(-1) === '/') {
    return path.slice(0, -1) + '/php/iusta-ovm-link.php';
  }
  return path + '/php/iusta-ovm-link.php';
}
